import { ConsoleLogger, defaultLogLevel } from './../Logger';
export function getLogger(uiLogLevel) {
    const logLevel = uiLogLevel || defaultLogLevel;
    return ConsoleLogger.getInstance(logLevel);
}
